// TODO: DEPRECATE and use TraceHubExService instead
angular.module('app').factory('TraceHubService', function ($rootScope) {

    // Ref: http://www.sitepoint.com/build-real-time-signalr-dashboard-angularjs/
    function backendFactory() {
        var connection = $.hubConnection('~/signalr');
        // NOTE: Switch on logging to see SignalR trace in console
        connection.logging = false;
        var proxy = connection.createHubProxy('traceHub');

        // NOTE: SignalR requires a method to be defined before we start up
        proxy.on('onInit', function () {
            // console.log('Connected with Id = ' + connId);
            $rootScope.$safeApply();
        });

        connection.connectionSlow(function () {
            console.log('Slow connection to SignalR server');
        });

        connection.error(function (error) {
            console.log('SignalR server connection error: ' + error);
        });

        // NOTE: Auto reconnect unless we have stopped the service ourselves
        var reconnect = false;
        // Ref: http://stackoverflow.com/questions/23375043/best-practice-for-reconnecting-signalr-2-0-net-client-to-server-hub
        connection.disconnected(function () {
            setTimeout(function () {
                if(!reconnect){return;}
                console.log('SignalR reconnecting');
                connection.start();
            }, 5000); // Restart connection after 5 seconds.
        });

        //var connState = { connecting: 0, connected: 1, reconnecting: 2, disconnected: 4 };

        var disconnected = $.connection.hub.state === $.signalR.connectionState.disconnected || true;
        var noHubState = $.connection.hub && !$.connection.hub.state;
        var isConnecting = false;

        // NOTE: Only start connection if we are not already connected
        //if ($.connection.hub && !$.connection.hub.state && $.connection.hub.state === $.signalR.connectionState.disconnected) {
        if (!isConnecting && (noHubState || disconnected)) {
            isConnecting = true;
            connection.start().done(function () {
                console.log('SignalR connected with transport = ' + connection.transport.name + ' id: ' + connection.id);
                $rootScope.$safeApply();
            }).fail(function () {
                console.log('SignalR failed to start');
            });
        }

        return {
            on: function (eventName, callback) {
                proxy.on(eventName, function (result) {
                    $rootScope.$safeApply(function () {
                        if (callback) {
                            callback(result);
                        }
                    });
                });
            },
            invoke: function (methodName, callback) {
                proxy.invoke(methodName)
                    .done(function (result) {
                        $rootScope.$safeApply(function () {
                            if (callback) {
                                callback(result);
                            }
                        });
                    });
            },
            // NOTE: Called from angular controllers on $destroy
            // NOTE: Add a stop function Ref: http://stackoverflow.com/questions/17813094/signalr-connection-freeze-other-ajax-requests
            stop: function (source) {
                if (connection && connection.state && connection.state !== 4 /* disconnected */) {
                    connection.stop();
                    reconnect = false;
                    console.log( source + ': SignalR connection closed and reconnect set to ' + reconnect);
                }
            }
        };
    }

    return backendFactory;
});